import dataTestIds from 'app/cypress/e2e/dataTestIds';
import { Platform } from 'quasar';
import { LOCALSTORAGE } from 'src/composables/const';
import { ROUTES } from 'src/router/routes';
import { useUserStore } from 'src/store/userStore';
import { ComponentInternalInstance, computed, getCurrentInstance } from 'vue';
import { useI18n } from 'vue-i18n';
import { NavigationFailure, useRouter } from 'vue-router';

export type LinkListItem = {
  text: string;
  routeName?: string;
  action: () => Promise<NavigationFailure | void | undefined> | void;
  hideOnCapacitor?: boolean;
  dataTestId?: string;
};

export default function useMenu() {
  const router = useRouter();
  const { t } = useI18n();
  const user = useUserStore();
  const { emit } = getCurrentInstance() as ComponentInternalInstance;

  const headerLinks = computed(() => {
    const defaultList: LinkListItem[] = [
      {
        text: t('home'),
        action: () => {
          emit('closeDrawer');
          void router.push({ name: ROUTES.HOME });
        },
        routeName: ROUTES.HOME,
        dataTestId: dataTestIds.HEADER.HOME,
      },
      {
        text: t('about'),
        action: () => {
          emit('closeDrawer');
          void router.push({ name: ROUTES.ABOUT });
        },
        routeName: ROUTES.ABOUT,
        dataTestId: dataTestIds.HEADER.ABOUT,
      },
      {
        text: `${t('homePage.howToTitle')}?`,
        action: () => {
          emit('closeDrawer');
          emit('scroll', ROUTES.HOW_IT_WORKS);
        },
        hideOnCapacitor: true,
        dataTestId: dataTestIds.HEADER.HOW_IT_WORKS,
      },
      {
        text: t('donationReports'),
        routeName: ROUTES.DONATION,
        action: () => {
          emit('closeDrawer');
          void router.push({ name: ROUTES.DONATION });
        },
        dataTestId: dataTestIds.HEADER.DONATION,
      },
      {
        text: t('signUp'),
        action: () => {
          if (Platform.is.capacitor) {
            return router.push({ name: ROUTES.SIGN_UP });
          }
          emit('closeDrawer');
          emit('scroll', ROUTES.SIGN_UP);
        },
        dataTestId: dataTestIds.HEADER.SIGN_UP,
      },
    ];
    if (!user.isLoggedIn) return defaultList;

    const newList = [...defaultList];
    newList.splice(4, 1);
    newList.push({
      text: t('logOut'),
      action: logout,
      dataTestId: dataTestIds.HEADER.LOG_OUT,
    });
    if (Platform.is.capacitor) {
      newList.push({
        text: t('deleteAccount'),
        action: () => {
          return router.push({ name: ROUTES.DELETE_ACCOUNT });
        },
        dataTestId: dataTestIds.HEADER.DELETE_ACCOUNT,
      });
    }
    return newList;
  });

  function logout() {
    localStorage.removeItem(LOCALSTORAGE.TOKEN);
    user.setToken(null);
    // Reload page
    emit('closeDrawer');
  }

  return { headerLinks };
}
